// extracted by mini-css-extract-plugin
module.exports = {"verticalNumberInput":"_1O6rX","disabled":"_2xuHE","arrowUp":"_1kKI6","arrowDown":"_1VQwg"};